import React from "react";
import logo from '../assets/uploads/2015/07/divine-yoga-center-mohali-chandigarh.jpg';

const services = [
  { name: "Yoga", icon: "🧘‍♂️", desc: "Traditional and modern yoga classes for all levels." },
  { name: "Naturopathy", icon: "🌱", desc: "Natural therapies and holistic healing." },
  { name: "Detox", icon: "💧", desc: "Personalized detox programs for body and mind." },
];

const testimonials = [
  { name: "Amit S.", text: "DivineWellness transformed my life! The yoga and therapy sessions are amazing." },
  { name: "Priya K.", text: "Professional instructors and a peaceful environment. Highly recommended!" },
];

function Home() {
  return (
    <div>
      {/* Hero Section */}
      <section className="relative h-[350px] md:h-[500px] flex items-center justify-center text-white text-center">
        <div className="absolute inset-0 bg-no-repeat bg-center bg-cover" style={{ backgroundImage: `url(${logo})` }}/>
        <div className="relative z-10">
          <h1 className="text-4xl md:text-6xl font-bold mb-4">Welcome to DivineWellness</h1>
          <p className="text-lg md:text-2xl mb-6">Yoga, Naturopathy &amp; Wellness Center</p>
          <a href="/appointment" className="inline-block bg-green-600 hover:bg-green-700 px-6 py-3 rounded text-white font-semibold shadow">Book an Appointment</a>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-12 bg-gray-50">
        <h2 className="text-3xl font-bold text-center mb-8">Our Services</h2>
        <div className="flex flex-wrap gap-8 justify-center">
          {services.map((srv) => (
            <div key={srv.name} className="bg-white rounded-lg shadow p-6 w-64 flex flex-col items-center">
              <div className="text-5xl mb-3">{srv.icon}</div>
              <h3 className="text-xl font-semibold mb-2">{srv.name}</h3>
              <p className="text-gray-600 text-center">{srv.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-12 bg-white">
        <h2 className="text-3xl font-bold text-center mb-8">Testimonials</h2>
        <div className="flex flex-wrap gap-8 justify-center">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-green-50 border-l-4 border-green-600 rounded shadow p-6 w-80">
              <p className="italic mb-2">“{t.text}”</p>
              <div className="font-bold text-green-700">- {t.name}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Home;
